// eslint-disable-next-line import/no-cycle
import http from '@/plugins/axios-monitoring';
// eslint-disable-next-line import/no-cycle
import router from '@/router/index';

interface ILogEvent {
  logType: string;
  userId: string;
  id?: string;
  key?: string;
}

export default class MonitoringService {
  private static routingStartTime = 0;

  public static sendPageMountedSpeed(): void {
    const stepName = String(router.currentRoute.value.name);
    const msMountSpeed = performance.now() - this.routingStartTime;
    this.sendMonitoringStep(stepName, msMountSpeed);
  }

  private static getNanoSec(ms: number) {
    return (ms * 1000000).toFixed(0); // 1 ms(p) = 1000000 ns(p)
  }

  public static isFirstPageMonitored = false;

  public static routingStarted(): void {
    this.routingStartTime = performance.now();
  }

  public static sendMonitoringStep(stepName: string, ms: number): void {
    const nanoSec = this.getNanoSec(ms);
    const url = `sampling/sample?id=FrontendApplicationInitialization&mapper=servicerequest&totaltime=${nanoSec}&stat=${stepName}`;
    http.get(url);
  }

  public static pingBackEnd(): Promise<{status: number}> {
    return http.get('/');
  }

  public static logEvents(payload: ILogEvent): void {
    const url = 'monitoring';
    http.post(url, payload).then((r) => (console.log(r)));
  }
}
